module.exports = __webpack_public_path__ + "static/img/post_5.bb7e14c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media-articles/posts/post_5.png
// module id = n3Uw
// module chunks = 0